/* Live */
import cookie from "react-cookies";
export const apiUrl = "https://erpapi.resmax.in/api/";
export const baseUrl = "https://erp.resmax.in/";
/* export const apiUrl = "http://localhost/resmax/api/";
export const baseUrl = "http://localhost:3000/"; */

export const adminlimit = "20";

var accesstoken = {
  Authorization: cookie.load("accessToken"),
};

export const headerconfig = {
  headers: accesstoken,
};
